import * as React from "react";

function PhoneMobileUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 28,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 12,
    x2: 36,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 52,
    x2: 34,
    y2: 52
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 29.35,
    rx: 3.98,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67 32.48s-3.34.89-4 2.65a10.88 10.88 0 0 0-.62 4.87H40a10.88 10.88 0 0 0-.64-4.82c-.64-1.76-4-2.65-4-2.65"
  }));
}

export default PhoneMobileUserIcon;